import { render, staticRenderFns } from "./SeleccionarParcelasComponent.vue?vue&type=template&id=603ff233"
import script from "./SeleccionarParcelasComponent.vue?vue&type=script&lang=js"
export * from "./SeleccionarParcelasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports